import React from "react";
import AuthenticityTokenField from "../../../components/forms/AuthenticityTokenField";
import { Button } from "../../../components/ui/button";
import {
  FieldLabel,
  SelectInput,
  TextInput,
} from "../../../components/ui/FormControls";
import type { MainAppPageProps } from "../types";

type InviteMemberFormProps = Pick<MainAppPageProps, "csrfToken" | "routes">;

export const InviteMemberForm: React.FC<InviteMemberFormProps> = ({
  csrfToken,
  routes,
}) => {
  const action =
    routes.organizationInvitations ?? "/organization/members/invitations";

  return (
    <form
      action={action}
      method="post"
      className="grid gap-4 sm:grid-cols-[1fr_10rem_auto] sm:items-end"
    >
      <AuthenticityTokenField csrfToken={csrfToken} />
      <div>
        <FieldLabel htmlFor="invitation_email">Email</FieldLabel>
        <TextInput
          id="invitation_email"
          name="invitation[email]"
          type="email"
          placeholder="teammate@example.com"
          required
        />
      </div>
      <div>
        <FieldLabel htmlFor="invitation_role">Role</FieldLabel>
        <SelectInput
          id="invitation_role"
          name="invitation[role]"
          defaultValue="member"
          required
        >
          <option value="admin">Admin</option>
          <option value="member">Member</option>
          <option value="viewer">Viewer</option>
        </SelectInput>
      </div>
      <Button type="submit" variant="premium">
        Send invite
      </Button>
    </form>
  );
};
